import React from 'react';
import TOOLTIP from '../config/tooltip.json';
import { FormattedMessage } from 'react-intl';
import { errorlog } from '../helpers/ErrorLogService';


//Over all tool tip component to access any where in over all the project 
export default class ToolTipComponent extends React.Component {

  constructor(props){
    super(props);
    this.state = {
        toolTipData  : null
    };

    this.styles = {};
    this.tooltipInformation = '';
    this.tooltipTitle = '';
    this.toolTipMouseOver = this.toolTipMouseOver.bind(this);
  }

  toolTipMouseOver(e){
    try {
    var tooldTipData = '';
    if (e.target.getAttribute('data-tooltip') !== null && e.target.getAttribute('data-tooltip') !== undefined && e.target.getAttribute('data-tooltip') !== '') {
      tooldTipData = { xPosition: e.pageX + 10, yPosition: e.pageY + 10, data: e.target.getAttribute('data-tooltip'), show: true };
    } else {
      tooldTipData = { show: false };
    }
    this.setState({
      toolTipData: tooldTipData
    });
  } catch (error) {
    //Error Severity: LOW
    errorlog(error, error.message, "ToolTipComponent-toolTipMouseOver")
  }
  }

  componentWillMount(){
    window.addEventListener("mousemove", this.toolTipMouseOver, false);
  }
  
  componentWillUpdate(nextProps, nextState){
    if(nextState.toolTipData.show){
      let toolTipdata = nextState.toolTipData.data.split("-"), componentData, leftPosition, topPosition, tooltipActualWidth;
      leftPosition = nextState.toolTipData.xPosition;
      topPosition = nextState.toolTipData.yPosition;
      if(toolTipdata[0] === "langId"){
        this.tooltipTitle = '';
        this.tooltipInformation = `${toolTipdata[0]}-${toolTipdata[1]}`;
      }else{
        let componentData = TOOLTIP[toolTipdata[0]][toolTipdata[1]] ; 
        this.tooltipTitle = Object.keys(componentData).includes('title') ? componentData.title : '';
        this.tooltipInformation = Object.keys(componentData).includes('data') ? componentData.data : '';

        
      }
      


      this.styles = {
          display : 'block',
          left    : leftPosition +'px',
          top     : topPosition +'px',
          
      }

    }else{
      this.tooltipTitle = '';
      this.tooltipInformation = '';
      this.styles = {
        display : 'none',
      }
    }
  }
  componentDidUpdate(prevProps){

  }
  
  render() {
    return (
      
        <React.Fragment>
          <div className="app-tooltip" style={this.styles}>
              <div className="tooltip-title" style={{display : this.tooltipTitle !== '' ? 'block' : 'none'}}>
                  {this.tooltipTitle}
              </div>
              {this.tooltipInformation.includes('langId') ? <div className="tooltip-information"><FormattedMessage id={`${this.tooltipInformation.split('-')[1]}`}></FormattedMessage></div> : <div className="tooltip-information">{this.tooltipInformation}</div>}
          </div>
        </React.Fragment>
    )
  }

}


// WEBPACK FOOTER //
// ./src/components/ToolTipComponent.js